import type { LiquidityStrategyDepositToken } from '@ui/utils/strategy';
import { resetWhenRouterChange } from '@ui/utils/zustandMiddleware';
import { create } from 'zustand';

export type UseStrategyStore = {
  amountStr: string;
  amountInputError: string | undefined;
  withdrawStr: string;
  withdrawInputError: string | undefined;
  depositToken: LiquidityStrategyDepositToken;
  withdrawToken: LiquidityStrategyDepositToken;
  checkedToken: LiquidityStrategyDepositToken;
};

export const useStrategyStore = create(
  resetWhenRouterChange<UseStrategyStore>(() => ({
    amountStr: '',
    amountInputError: undefined,
    withdrawStr: '',
    withdrawInputError: undefined,
    depositToken: 'cro',
    checkedToken: 'cro',
    withdrawToken: 'ferroLP',
  })),
);
